<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>文案分配</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-form inline label-position="right" label-width="60px" size="small" class="query-form">
        <SelectAbroad
          v-on:selabroad="function(str){query.time=str;getCollect();}"
          :time="query.time"
        ></SelectAbroad>
        <el-form-item>
          <el-button type="primary" @click="getCollect();">查询</el-button>
        </el-form-item>
      </el-form>

      <div style="height:20px;"></div>
      <el-card class="box-card collectCard" shadow="always">
        <div class="clearfix" slot="header">
          <span>数据详情 ({{query.time||'全部'}})</span>
        </div>
        <div class="index-card" style="height:auto;">
          <el-table :data="list" stripe style="width: 100%; ">
            <el-table-column prop="realName" label="文案老师"></el-table-column>
            <el-table-column prop="allCount" label="分配总数" sortable></el-table-column>
            <el-table-column prop="outCount" label="退出人数" sortable></el-table-column>
            <el-table-column prop="realCount" label="完成人数" sortable></el-table-column>
          </el-table>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import "echarts/theme/macarons.js";
import url from "@/plugins/urlHelper.js";
import SelectAbroad from "@/components/SelectAbroad";
export default {
  data() {
    return {
      domain: url.getDomain(),
      query: {}, //对象
      loading: false,
      currentPage4: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      dialogVisible: false,
      submiting: false,
      list: [] //数据详情
    };
  },
  components: {
    SelectAbroad
  },
  methods: {
    //获取学校统计，地区统计
    getCollect() {
      var _this = this;
      //柱状图
      var link2 = url.getCollect("getdoc");
      $.get(link2, _this.query, data => {
        _this.list = data;
      });
    }
  },
  created() {},
  mounted() {
    //初始化时间
    var now = new Date();
    var month = now.getMonth() + 1;
    var result = 1;
    for (var i = 0; i < month; i++) {
      var temp = month - i;
      if (temp == 1 || temp == 4 || temp == 7 || temp == 10) {
        result = temp;
        break;
      }
    }
    this.query.time = now.getFullYear() + "-" + result;
    //加载列表
    this.getCollect();
  }
};
</script>

<style>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
.el-form-item--small.el-form-item {
  margin-right: 0px;
}
.el-button--primary {
  margin-left: 10px;
}
</style>
